/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const PlayTv: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="play-tv" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M831.13 793.3475L566.6949999999999 604.4775V982.26L831.13 793.39zM113.3475 1057.7825C113.3475 1120.385 164.0925 1171.13 226.695 1171.13H1133.3474999999999C1195.9499999999998 1171.13 1246.695 1120.385 1246.695 1057.7825V528.9125C1246.695 466.3100000000001 1195.9499999999998 415.565 1133.3474999999999 415.565H717.7824999999998V264.435H982.2174999999997V188.8699999999999H377.7824999999999V264.435H642.2174999999999V415.565H113.3474999999999V1057.7825zM226.6525 1095.565C205.785 1095.565 188.87 1078.65 188.87 1057.7825V491.1299999999999H1133.305C1154.1725 491.1299999999999 1171.0875 508.0449999999998 1171.0875 528.9124999999999V1057.7824999999998C1171.0875 1078.6499999999999 1154.1725 1095.5649999999998 1133.305 1095.5649999999998H226.6525000000001z" : "M664.904 634.678L453.356 483.582V785.808L664.904 634.712zM90.678 846.226C90.678 896.308 131.274 936.904 181.356 936.904H906.6779999999998C956.7599999999998 936.904 997.3559999999998 896.308 997.3559999999998 846.226V423.13C997.3559999999998 373.048 956.7599999999998 332.452 906.6779999999998 332.452H574.2259999999999V211.5479999999999H785.7739999999999V151.096H302.226V211.5479999999999H513.7739999999999V332.452H90.6779999999999V846.226zM181.322 876.452C164.628 876.452 151.096 862.92 151.096 846.226V392.9039999999999H906.644C923.338 392.9039999999999 936.87 406.4359999999999 936.87 423.1299999999999V846.2259999999999C936.87 862.9199999999998 923.338 876.4519999999999 906.644 876.4519999999999H181.3220000000001z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
PlayTv.displayName = `Blueprint5.Icon.PlayTv`;
export default PlayTv;
